
import { v4 as uuidv4 } from 'uuid'

const toolEnum = {
  state: {
    uuid: ''
  },

  mutations: {
    SET_UUID: (state) => {
      state.uuid = uuidv4()
    },
    clear_UUID: (state) => {
      state.uuid = ''
    },
  },

  actions: {
    setUuid({ commit }) {
      commit('SET_UUID')
    },

    clearUuid({ commit }) {
      commit('clear_UUID')
    },
  },
}

export default toolEnum
